export default "__VITE_ASSET__e3b0d892__"